export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["ADMIN_APPROVAL"] = "ADMIN_APPROVAL";
    Type["PAID_PLANS"] = "PAID_PLANS";
    Type["EVENTS"] = "EVENTS";
})(Type || (Type = {}));
export var PrivacyLevel;
(function (PrivacyLevel) {
    PrivacyLevel["UNKNOWN"] = "UNKNOWN";
    /** Anyone can see the group in the group list and view its content. Anyone can join. */
    PrivacyLevel["PUBLIC"] = "PUBLIC";
    /** Anyone can see the group in the group list, but only group members can see its content. In order to join a group, a group join request must be submitted. */
    PrivacyLevel["PRIVATE"] = "PRIVATE";
    /** Only group members and admins can see the group in the group list. New group members can only be added by existing group members. */
    PrivacyLevel["SECRET"] = "SECRET";
})(PrivacyLevel || (PrivacyLevel = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["USER"] = "USER";
    IdentityType["MEMBER"] = "MEMBER";
})(IdentityType || (IdentityType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Membership;
(function (Membership) {
    Membership["UNKNOWN_MEMBERSHIP"] = "UNKNOWN_MEMBERSHIP";
    /** Site member is not a group member. */
    Membership["NONE"] = "NONE";
    /** Site member is a group member. */
    Membership["JOINED"] = "JOINED";
    /** Site member has join request with PENDING status for this group. */
    Membership["PENDING"] = "PENDING";
})(Membership || (Membership = {}));
export var Role;
(function (Role) {
    Role["UNKNOWN_ROLE"] = "UNKNOWN_ROLE";
    /** Regular group member. */
    Role["MEMBER"] = "MEMBER";
    /** Group administrator. */
    Role["ADMIN"] = "ADMIN";
})(Role || (Role = {}));
//# sourceMappingURL=types.js.map